import { Box, CircularProgress, Drawer } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./MobileCategoryPage.css";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { UserContext } from "../../../../App";
import { aggsFilterCategory } from "../../../../config/Services";
import { ChevronRight } from "@mui/icons-material";
import MobileProductList from "./MobileProductList";

const MobileCategoryPage = ({
  goToMobileCategory,
  setGoToMobileCategory,
  increseItemQuantityTroughParticularCategory,
  setAddOnModalOpen,
  setAddOnProductList,
  setVariantProductList,
  setSelectedProductForCart,
  addItemLoader,
  setAddItemLoader,
  openProductList,
  setOpenProductList
}) => {
  const [categoriesData, setCategoriesData] = useState([]);
  const [categoriesLoader, setCategoriesLoader] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const { saleMode } = useContext(UserContext);

  const orgId = localStorage.getItem("orgId");
  const locId = localStorage.getItem("locId");

  const handleMobileCategoryClose = () => {
    setGoToMobileCategory(false);
  };

  const fethcCategories = () => {
    setCategoriesLoader(true);
    const payload = {
      page: 1,
      pageSize: 20,
      storeIds: [orgId],
      storeLocations: [locId],
      sortByUpdatedAt: "DESC",
      productTypes: ["MENU"],
      salesChannels: [saleMode],
    };
    aggsFilterCategory(payload)
      .then((res) => {
        const newData = res?.data?.data?.data || [];
        setCategoriesData((prev) => [...prev, ...newData]);
        if (newData?.length < 20) {
          setHasMore(false);
        }
        setCategoriesLoader(false);
      })
      .catch((err) => {
        setCategoriesLoader(false);
      });
  };

  useEffect(() => {
    if (goToMobileCategory) {
      fethcCategories();
    }
  }, [goToMobileCategory]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setOpenProductList(true);
  };

  return (
    <Drawer
      anchor="bottom"
      open={goToMobileCategory}
      onClose={() => {}}
      ModalProps={{ disableEscapeKeyDown: true, sx: { zIndex: 1500 } }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          p: 2,
          overflow: "hidden",
        }}
        role="presentation"
      >
        <div className="mobileCategoryHeader">
          <p>Categories</p>
          <PosCustomIcon
            icon={<XMarkIcon />}
            height={"20px"}
            width={"20px"}
            pointer={true}
            onClickFunction={handleMobileCategoryClose}
          />
        </div>
        <div className="mobileCategoryData">
          {categoriesLoader ? (
            <div className="mobileCatLoader">
              <CircularProgress size={"24px"} sx={{ color: "var(--blue-b0)" }} />
            </div>
          ) : categoriesData && categoriesData?.length > 0 ? (
            <ul className="mobileCategoryList">
              {categoriesData?.map((category, idx) => (
                <li
                  key={idx}
                  className="mobileCategoryItems"
                  onClick={() => handleCategoryClick(category?.key)}
                >
                  {category?.key}
                  <PosCustomIcon
                    icon={<ChevronRight />}
                    height={"16px"}
                    width={"16px"}
                    color="var(--surface-black)"
                  />
                </li>
              ))}
            </ul>
          ) : (
            <div className="mobileEmptyCatData">
              <p>No Categories Found</p>
            </div>
          )}
        </div>
        <MobileProductList
          category={selectedCategory}
          openProductList={openProductList}
          setOpenProductList={setOpenProductList}
          increseItemQuantityTroughParticularCategory={increseItemQuantityTroughParticularCategory}
          setAddOnModalOpen={setAddOnModalOpen}
          setAddOnProductList={setAddOnProductList}
          setVariantProductList={setVariantProductList}
          setSelectedProductForCart={setSelectedProductForCart}
          setGoToMobileCategory={setGoToMobileCategory}
          addItemLoader={addItemLoader}
          setAddItemLoader={setAddItemLoader}
        />
      </Box>
    </Drawer>
  );
};

export default MobileCategoryPage;
